import React, { Component } from 'react'
import $ from 'jquery'
import 'react-confirm-alert/src/react-confirm-alert.css'
import DataTable from 'datatables.net' // Used by JQuery styles
import PageTitle from "./../../components/common/PageTitle";
import { Alert, Container, Row, Col, Button, Card, CardHeader, CardBody} from "shards-react";
import { Redirect, Link } from 'react-router-dom'
import { confirmAlert } from 'react-confirm-alert';
import {PropTypes} from 'prop-types'
import {connect} from 'react-redux'

import auth from '../../components/common/Auth';
import history from '../../history';
import { UsersAPI, AccountUserAPI } from '../../components/apis';
import types from '../../types/types';

var sessionUser =  null;

class Users extends Component {
  constructor (props, context) {
    super(props, context)
    this.state = {
      loading: true,
      users: [],
      apiErr: null,
    }
    this.api = new UsersAPI(auth.getAccessToken());

  }

  _getUsers() {
    this.setState({
      loading: true,
    });

    const self = this;

    const token = auth.getAccessToken();
    var accountId = this.props.idAccount;
    var accountUserApi = new AccountUserAPI(token, accountId);

    var filters = "?account_id="+accountId;

    accountUserApi.getAllUsers(filters).then(usersAccounts => {

         self.api.getAll(filters).then(allUsers => {

           var users = [];

           for (var i = 0; i < allUsers.length; i++) {
             var exist = false;

             for (var x = 0; x < usersAccounts.length; x++) {
                if(usersAccounts[x].user_id === allUsers[i].id){
                    exist = true;
                    break;
                };
             };

             if (exist) users.push(allUsers[i]);
           };

           self.setState({
             loading: false,
             users: users,
           })
           if (users.length > 0){
             setTimeout(self.loadTable, 200);
           }
         }).catch(err => {
           self.setState({
             loading: false,
             apiErr: err,
           })
         });

      }).catch(err => {
         self.setState({
          loading: false,
          apiErr: err,
        })
    });

  }

  goBack = () => {
    history.goBack();
  }

  retry = () => {
    this.setState({
      loading: true,
      apiErr: null,
      users: []
    }, this._getUsers)
  }

  removeUser = (id, name) => {
    const self = this;
    confirmAlert({
      title: '',
      message: 'Esta seguro que desea borrar el usuario: '+ name,
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            self.setState({
              loading: true
            })

            self.usersTable.clear();
            self.usersTable.destroy();

            self.api.delete(id).then(() => {
              self._getUsers();
            }).catch(err => {
              self.setState({
                apiErr: err,
              });
            });
          }
        },
        {
          label: 'No',
          onClick: () => {}
        }
      ]
    })
  }

  componentDidMount () {
    sessionUser =  auth.getSessionUser();
    this._getUsers()
  }

  loadTable = () => {
    this.usersTable = $('#usersTable').DataTable({
        "ordering": false,
        "destroy": true,
        "lengthMenu": [[5, 10, 20, -1], [5, 10, 20, this.context.t('All')]],
        "columnDefs": [
            {
            targets: [ 0 ],
                className: 'mdl-data-table__cell--non-numeric'
            }
        ],
        "language": {
             "sProcessing":     this.context.t("Processing..."),
             "sLengthMenu":     this.context.t("Show _MENU_ entries"),
             "sZeroRecords":    this.context.t("No matching records found"),
             "sEmptyTable":     this.context.t("No data available in table"),
             "sInfo":           this.context.t("Showing _START_ to _END_ of _TOTAL_ entries"),
             "sInfoEmpty":      this.context.t("Showing 0 to 0 of 0 entries"),
             "sInfoFiltered":   this.context.t("(filtered from _MAX_ total entries)"),
             "sInfoPostFix":    "",
             "sSearch":         this.context.t("Search"),
             "sUrl":            "",
             "sInfoThousands":  ",",
             "sLoadingRecords": this.context.t("Loading"),
             "oPaginate": {
                 "sFirst":    this.context.t("First"),
                 "sLast":     this.context.t("Last"),
                 "sNext":     this.context.t("Next"),
                 "sPrevious": this.context.t("Previous")
             },
             "oAria": {
                 "sSortAscending":  this.context.t(": activate to sort column ascending"),
                 "sSortDescending": this.context.t(": activate to sort column descending")
             }
        }
    });
  }

  goToNewUser = () => {
    return <Redirect to='/users/new' />
  }

  dismiss = () => {
    this.setState({
      apiErr: null
    });
  }

  render () {

    var accountId = this.props.idAccount;

    // if (!auth.isAuthenticated()){
    //   return <Redirect to='/' />
    // }

    if (this.state.loading) {
      return (
        <div>
          <Container fluid>
            <br/>
            <div className="container center">
              <h5><i className="fas fa-spinner fa-pulse"></i> {this.context.t('Loading...')}</h5>
            </div>
          </Container>
        </div>
      )
    }

    if (this.state.apiErr) {
      return (
        <div>
          <Container fluid className="px-0">
            <Alert dismissible={this.dismiss} open={true} className="red mb-0"><i className="material-icons">error</i> {this.context.t('There was a mistake')}: {JSON.stringify(this.state.apiErr)} </Alert>
          </Container>
            <Container fluid className="main-content-container px-4 pb-4">
              <div className="error">
                <div className="error__content">
                  <h2>500</h2>
                  <h3>{this.context.t('Something went wrong!')}</h3>
                  <p>{this.context.t('There was a problem on our end. Please try again later.')}</p>
                  <Button onClick={this.retry} pill><i className="material-icons">refresh</i> {this.context.t('Reload')}</Button>
                </div>
              </div>
            </Container>
        </div>
      )
    }

    const users = this.state.users
    return (
      <div>
        <Container fluid className="main-content-container px-4">
          <Row noGutters className="page-header py-4">
            <PageTitle title={this.context.t('Users')} subtitle={this.context.t('List')} className="text-sm-left mb-3" />
            <Link to={'/accounts/'+accountId+'/users/new'}>
            <Button size="sm" theme="white" className="mb-2 mr-1" pill>
              <i className="material-icons md-18">person_add</i>
            </Button>
            </Link>

            <Button size="sm" theme="white" className="mb-2 mr-1"  onClick={e => {this.goBack()}}  pill>
            <i className="material-icons mx-3" style={{ float: "right", cursor: "pointer", fontSize: "20px"}}>arrow_back</i>
            </Button>
          </Row>
          <br/>
          <table id="usersTable" className="mdl-data-table" width="100%">
            <tbody>
              { users.length > 0 ? users.map(user => {
                    return (
                      <tr key={user.id} style={{ margin: '10px' }}>
                        <td>
                          <Card small className="h-100" style={{ marginBottom: '20px'}}>
                            <CardHeader style={{padding: "10px 10px 0px 10px", borderBottom: "1px solid #fafafa"}}>
                              <h6 className="m-0">
                                <i className="material-icons md-24" style={{float: "left"}}>account_circle</i>
                                <span style={{float: "left", marginTop: "2px", marginLeft: "6px"}}>{user.getFullName()}</span>
                              </h6>

                              <Link to={'/users/'+user.id+"/account/"+user.account_id}>
                                <Button size="s" theme="white" className="mb-2 mr-1 pull-right" style={{padding: "5px"}}>
                                  <i className="material-icons">remove_red_eye</i>
                                </Button>
                              </Link>

                              {(sessionUser.roles[0].id === types.USER_ROOT_ID || sessionUser.roles[0].id === types.USER_ADMIN_ID) ? (
                                  <Link to={'/users/edit/'+user.id}>
                                    <Button size="s" theme="white" className="mb-2 mr-1 pull-right" style={{padding: "5px"}}>
                                        <i className="material-icons">edit</i>
                                    </Button>
                                  </Link>
                              ) : (
                                ''
                              )}

                            </CardHeader>
                            <CardBody className="pt-0">
                              <br/>
                              <Row>
                                <Col lg="12" className="pb-1">
                                  <i className="material-icons">email</i> {user.email}
                                </Col>
                                <Col lg="12" className="pb-1">
                                  <i className="material-icons">local_phone</i> {user.phone_number}
                                </Col>
                              </Row>
                              <br/>
                              <small className="pull-right"> <i className="material-icons">access_time</i> {user.created_at}</small>
                            </CardBody>
                          </Card>
                        </td>
                      </tr>
                    )
                  }) :
                <tr>
                  <td>
                    <Alert className="mb-0 info">
                      <i className="fa fa-info mx-2"></i> {this.context.t("There is no user to show.")}
                    </Alert>
                    <br/>
                  </td>
                </tr>
              }
            </tbody>
           </table>
        </Container>
        <br/>
        <br/>
      </div>
    )
  }
}

Users.contextTypes = {
  t: PropTypes.func.isRequired
}

export default connect(state => ({
  lang: state.i18nState.lang
}))(Users)
